<script setup lang="ts"></script>

<template>
  <div>{{ $t('common.previews') }}</div>
</template>
